import React from 'react';
import { Route } from 'react-router-dom';
import { Result, Button } from 'antd';
import { AuthStore } from '../stores/Auth';
import { GlobalStore } from 'stores/Global';

export const AdminRoute = ({ component: Component, ...rest }: any) => {
  return (
    <Route {...rest} render={props => (
      AuthStore.isAdmin ? (
        <Component {...props} />
      ) : (
          <Result
            status="403"
            title="403"
            subTitle="Sorry, you are not authorized to access this page."
            extra={
              <Button type="primary" onClick={() => GlobalStore.navigate('/')}>
                Back Home
              </Button>
            }
          />
        )
    )} />
  );
};